import useSWR from 'swr';

import { fetchFromOldApi } from '~/services/Http';

import {
  LegacyAllowanceProposalWorkflow,
  LegacyBenefitProposalWorkflow,
  LegacySalaryProposalWorkflow,
} from './types';

export const getLegacyAllowanceProposalWorkflowTableData = (
  employeeId: number | string,
  employmentId: number | string,
  employmentSubUid: string,
): Promise<LegacyAllowanceProposalWorkflow[]> => {
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/allowanceproposal/${employmentSubUid}/workflow`,
  ).then((r) => r.json());
};

export const getLegacyBenefitProposalWorkflowTableData = (
  employeeId: number | string,
  employmentId: number | string,
  employmentSubUid: string,
): Promise<LegacyBenefitProposalWorkflow[]> => {
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/benefitproposal/${employmentSubUid}/workflow`,
  ).then((r) => r.json());
};

export const getLegacySalaryProposalWorkflowTableData = (
  employeeId: number | string,
  employmentId: number | string,
  employmentSubUid: string,
): Promise<LegacySalaryProposalWorkflow[]> => {
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/salaryproposal/${employmentSubUid}/workflow`,
  ).then((r) => r.json());
};

type PropsType = {
  employeeId: number;
  employmentId: number | string;
  employmentSubUid: string;
};

export const useLegacyAllowanceProposalWorkflowTableData = (
  props: PropsType,
) => {
  const { employeeId, employmentId, employmentSubUid } = props;

  const { data, isLoading, error } = useSWR(
    [
      'legacyAllowanceProposalWorkflowTableData',
      employeeId,
      employmentId,
      employmentSubUid,
    ],
    () =>
      getLegacyAllowanceProposalWorkflowTableData(
        employeeId,
        employmentId,
        employmentSubUid,
      ),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};

export const useLegacyBenefitProposalWorkflowTableData = (props: PropsType) => {
  const { employeeId, employmentId, employmentSubUid } = props;

  const { data, isLoading, error } = useSWR(
    [
      'legacyBenefitProposalWorkflowTableData',
      employeeId,
      employmentId,
      employmentSubUid,
    ],
    () =>
      getLegacyBenefitProposalWorkflowTableData(
        employeeId,
        employmentId,
        employmentSubUid,
      ),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};

export const useLegacySalaryProposalWorkflowTableData = (props: PropsType) => {
  const { employeeId, employmentId, employmentSubUid } = props;

  const { data, isLoading, error } = useSWR(
    [
      'legacySalaryProposalWorkflowTableData',
      employeeId,
      employmentId,
      employmentSubUid,
    ],
    () =>
      getLegacySalaryProposalWorkflowTableData(
        employeeId,
        employmentId,
        employmentSubUid,
      ),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
